var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "h-full w-full flex items-center" }, [
    _c("div", { staticClass: "w-full" }, [
      _c(
        "div",
        { staticClass: "mb-12" },
        [
          _c("SectionTitle", {
            staticClass: "mb-1",
            attrs: { title: "Company" },
          }),
          _c("UiButton", {
            attrs: {
              buttonText: "30 Day Free Trial",
              buttonClasses: "font-bold py-3 text-xl",
              size: "no",
              variant: "accent",
              fullWidth: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("roleUpdated", _vm.roles.ADMIN)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("SectionTitle", {
            staticClass: "mb-1",
            attrs: { title: "Contractor" },
          }),
          _c("UiButton", {
            attrs: {
              buttonText: "Register for Free",
              buttonClasses: "font-semibold py-3 text-xl",
              size: "no",
              fullWidth: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("roleUpdated", _vm.roles.CONTRACTOR)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }